import React from 'react'

interface Props {
  className?: string
  title?: string
}

/**
 * The Sondely mark: three measurements rising, joined by the line between them.
 * One reading of the product in one glyph, and the shape the favicon and the
 * social card reuse.
 */
const BrandMark: React.FC<Props> = ({ className = 'h-8 w-8', title }) => (
  <svg viewBox="0 0 32 32" className={className} role="img" aria-label={title} focusable="false">
    {title ? <title>{title}</title> : null}
    <rect width="32" height="32" rx="9" fill="#3B3D93" />
    <path d="M7 22.5 L14 16 L20 18.5 L25.5 9.5" fill="none" stroke="#6EE7B7" strokeWidth="2.2"
      strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="7" cy="22.5" r="2.6" fill="#FFFFFF" />
    <circle cx="14" cy="16" r="2.6" fill="#FFFFFF" />
    <circle cx="25.5" cy="9.5" r="3.2" fill="#FBBF24" />
  </svg>
)

export default BrandMark
